import type { DocumentNode } from 'graphql';
import { getClient } from 'lane-shared/apollo';
import type { VisitorPassQueryResponse } from 'application-types';
import { getScheduledVisits as getScheduledVisitsGraphqlQueries } from 'graphql-queries';
import { ScheduledVisitsResponse } from '..';

export async function getScheduledVisits(
  from: Date,
  to: Date,
  channelId: string,
  query: DocumentNode = getScheduledVisitsGraphqlQueries
): Promise<VisitorPassQueryResponse[]> {
  const response = await getClient().query<ScheduledVisitsResponse>({
    query,
    variables: {
      startDate: from.toISOString(),
      endDate: to.toISOString(),
      channelId,
    },
  });

  const scheduledVisits = response.data.scheduledVisits.result.visits;

  return scheduledVisits;
}
